import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
	selector: "dmv-confirm-model",
	templateUrl: "./confirm-model.component.html",
	styleUrls: ["./confirm-model.component.css"]
})
export class ConfirmModelComponent implements OnInit {
	constructor() {}
	public isPopupOpen: boolean = true;

	@Output() public removeConfirm: EventEmitter<any> = new EventEmitter();
	@Output() public continueConfirm: EventEmitter<any> = new EventEmitter();

	ngOnInit() {}
	public close() {
		this.isPopupOpen = false;
		this.continueConfirm.emit();
	}
	public remove() {
		this.isPopupOpen = false;
		this.removeConfirm.emit();
	}
}
